import { auth, defaultIMG, imgBaseURL } from "helper/Utility"
import React from "react"
import { Link, useNavigate } from "react-router-dom"
import LoginAuth from "./LoginModal"
import { useState } from "react"
import { currencyText } from "helper/Constant"

const ProductBox = ({ item }) => {
    const navigate = useNavigate()
    const [loginModal, setLoginModal] = useState(false)
    const handleCloseLoginModal = () => setLoginModal(false)
    const handleRedirect = (type, data) => {
        if (type === "chat") {
            auth("user") ? navigate(`/chat/conversation`, { state: data }) : setLoginModal(true)
        }
    }
    return (
        <>
            <div className="product-boxes">
                {/* <div className="freeproducts">Free</div> */}

                <Link to={`/product-details/${item?._id}`} className="nn_homproductctn">
                    <img alt="" src={item?.gallery?.length > 0 ? imgBaseURL() + item?.gallery[0] : defaultIMG} />
                </Link>
                <div className="product-boxes_inner">
                    <h2>
                        <Link to={`/product-details/${item?._id}`} className="product-title">
                            {" "}
                            {item?.title}
                        </Link>
                    </h2>
                    {item?.location && (
                        <p>
                            <i className="fa fa-location-dot"></i> {item?.location}
                        </p>
                    )}
                    <p className="price-products">
                        {currencyText} {item?.price}
                    </p>
                </div>
            </div>

            <LoginAuth show={loginModal} handleClose={handleCloseLoginModal} />
        </>
    )
}

export default ProductBox
